import {useState, useEffect} from "react";
import axios from 'axios';
import "./../../../css/Forms.css";
import "./../../../css/SARsTable.css";
import { statusIsGood } from "../../../helpers/http";
import { IoFilterOutline } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';

export default function SAR_Faculty_Table({ CurrentUser }) {
    const { year } = useParams();
    const [isLoaded, setIsLoaded] = useState(false);
    const [currentYear, setCurrentYear] = useState(2026);
    const [years, setYears] = useState([]);
    const [allFaculty, setAllFaculty] = useState([]);
    const [sars, setSARs] = useState([]);
    const [filteredSARs, setFilteredSARs] = useState([]);
    const [maxAdvisors, setMaxAdvisors] = useState(1);
    const [showFilters, setShowFilters] = useState(false);
    const [filters, setFilters] = useState({
        milestones: 0,
        status: 2,
        advisors: [""],
        fivePlus: 0,
        progressValue: 0,
        gphValue: 0,
        gphStatus: -1,
        sort1: {
            field:"studentPID",
            direction: 1
        },
        sort2: {
            field:"",
            direction: 1
        },
    });

    function displayTerm(term) {
        if(term === 0) return "-";
        let s = term%100 === 1 ? "Spring " : term%100 === 9 ? "Fall " : "ERROR ";
        let y = String(Math.floor(term/100));
        return s+y;
    }

    function displayMilestone(milestone) {
        if(milestone.status === null) return "-";
        else if(milestone.term === 0) return "-";
        if(milestone.status === 1)
            return `Completed ${displayTerm(milestone.term)}`;
        else
            return `Planned ${displayTerm(milestone.term)}`;
    }

    useEffect(() => {
        setUp();
    }, []);

    const setUp = async() => {
        //Determine what year to pull
        let y = parseInt(typeof year === "undefined" ? new Date().getFullYear() : year);
        setCurrentYear(y);
        //Pull the list of advisors
        await fetchFacultyAdvisors();
        //Pull the list of years
        await fetchYears();
        //Pull the SARs for the year
        await fetchSARs(y);
        setIsLoaded(true);
    }

    /** Fetches all of the faculty advisors */
    const fetchFacultyAdvisors = async () => {
        return axios.get("/api/faculty").then((response) => {
            setAllFaculty(response.data.faculty);
            //If user is a faculty member, set the filter to them
            if(response.data.faculty.some((fac) => CurrentUser.pid === fac.pid))
                setFilters({
                    ...filters,
                    advisors: [CurrentUser.pid]
                });
        }).catch((error) => {
            if (error.response) {
                console.error('Error getting faculty:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message)
            }
            alert(`Error getting faculty, \nContact an admin if this persists.`);
            setAllFaculty([]);
        });
    }

    const fetchSARs = async (y) => {
        return axios.get(`/api/sars/years/${y}`).then((response) => {
            let adCount = 0;
            setSARs(response.data.sars.map((sar, index) => {
                let s = {
                    ...sar,
                    entered: JSON.parse(sar.entered),
                    pos: JSON.parse(sar.pos),
                    qualifier: JSON.parse(sar.qualifier),
                    prelim: JSON.parse(sar.prelim),
                    research: JSON.parse(sar.research),
                    final: JSON.parse(sar.final),
                    advisors: sar.advisors === null ? [] : JSON.parse(sar.advisors),
                    gphReview: sar.gphReview === null ? [] : JSON.parse(sar.gphReview),
                }
                if(s.advisors !== null && s.advisors.length > adCount)
                    adCount = s.advisors.length;
                return s;
            }));
            setMaxAdvisors(adCount);
        }).catch((error) => {
            if (error.response) {
                console.error('Error getting SARs:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message)
            }
            alert(`Error getting SARs, \nContact an admin if this persists.`);
            window.location.href = "/";
        });
    }
    
    async function fetchYears() {
        return new Promise((resolve, reject) => {
            axios.get(
                "/api/sar/years"
            ).then((response) => {
                setYears(response.data.years.map(y => y.year));
                return resolve();
            }).catch((error) => {
                if(error.response) {
                    console.error(`Error getting years: `, error.response);
                } else if(error.request) {
                    console.error(`Got no response to request: `, error.request);
                } else {
                    console.error(`Error: `, error)
                }
                alert(`Error getting years, \nContact an Admin if this persists.`);
                setYears([]);
                return resolve();
            });
        });
    }

    const filterSARs = () => {
        setFilteredSARs(
            sars.filter((sar) => {
                //Status Filtering
                if(filters.status === 0 && sar.sarStatus > 1) //unsubmitted
                    return false;
                else if(filters.status === 1 && sar.sarStatus < 2) //submitted
                    return false;
                //Five Plus Years Filtering
                if(filters.fivePlus === 1) {
                    if(sar.entered.term <= 0) return false; //No entered
                    if(Math.floor(sar.entered.term/100)+5 > currentYear)
                        return false;//Entered too recently
                }
                //Progress Value Filtering
                if(filters.progressValue > 0) { //Reviews with a specific value
                    if(!sar.advisors.some((advisor) => advisor.progressValue === filters.progressValue))
                        return false;
                } else if(filters.progressValue === -1) { //SARs w/o reviews OR reviews w/o progress values
                    if(sar.advisors.length > 0) { //Has a review?
                        let t = sar.advisors.some((advisor) => advisor.progressValue === null)
                        if(!t) return false;
                    }
                }
                //GPH Value Filtering
                if(filters.gphValue === -1 && sar.gphReview.progressValue !== null) {
                    return false; //No value
                } else if(filters.gphValue > 0 && sar.gphReview.progressValue !== filters.gphValue) {
                    return false; //Review w/ specific value
                } 
                //GPH Status Filtering
                if(filters.gphStatus === 0 && sar.gphReview.reviewStatus === null) {
                    //Not started
                } else if(filters.gphStatus >= 0 && sar.gphReview.reviewStatus !== filters.gphStatus) {
                    return false;
                }
                //Advisor Filtering
                if(filters.advisors.includes("")) {//All advisors
                    return true;
                }
                if(filters.advisors.includes("none") && sar.advisors.length === 0) { //No advisors
                    return true;
                } else { //Specific advisors
                    let r = sar.advisors.filter((advisor) => {
                        let inc = filters.advisors.includes(advisor.advisorPID)
                        return inc;
                    });
                    return r.length > 0;
                }
            }).sort((a,b) => {
                //Primary Sort
                if(a[filters.sort1.field] > b[filters.sort1.field])
                    return filters.sort1.direction;
                else if(a[filters.sort1.field] < b[filters.sort1.field])
                    return -1 * filters.sort1.direction;
                //Secondary Sort
                if(filters.sort2.field === "") //No secondary sort
                    return 0;
                else if(a[filters.sort2.field] > b[filters.sort2.field])
                    return filters.sort2.direction;
                else if(a[filters.sort2.field] < b[filters.sort2.field])
                    return -1 * filters.sort2.direction;
                else
                    return 0;
            })
        );
    }

    const gpcShareAll = () => {
        //Double check permissions
        if(CurrentUser.permissions <= 0) {
            alert("Stop that!");
            return;
        }
        //Confirm they want to do this
        if(!window.confirm("Are you sure you would like to share all GPH reviews? This cannot be undone."))
            return;
        //Hit up the API
        axios.get(`/api/sar_evals/sharegph/${currentYear}`).then((response) => {
            console.log(response);
            fetchSARs(currentYear);
            alert(response.data.message);
        }).catch((error) => {
            if (error.response) {
                console.error('Error sharing SARs:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message)
            }
            alert(`Error sharing SARs, \nContact an admin if this persists.`);
        })
    }

    const gpcSetDefault = () => {
        //Double check permissions
        if(CurrentUser.permissions <= 0) {
            alert("Stop that!");
            return;
        }
        //Confirm they want to do this
        if(!window.confirm("Are you sure you would like to set a default review for all SARs that received a positive average progress score? These reviews will not be automatically shared and you will be able to modify them further until you do share them.")) {
            return;
        }
        //Make the API Call
        axios.get(`/api/sar_evals/gphdefault/${currentYear}`).then((response) => {
            console.log(response);
            fetchSARs(currentYear);
            alert("Set Default Reviews");
        }).catch((error) => {
            if (error.response) {
                console.error('Error setting Default Reviews:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message);
            }
            alert(`Error setting Default Reviews, \nContact an admin if this persists.`);
        });
    }

    useEffect(() => {
        filterSARs();
    }, [filters, sars]);

    useEffect(() => {
        if(!isLoaded) return;
        fetchSARs(currentYear);
    }, [currentYear]);

    if(!isLoaded)
        return(
            <div className="page-body">
                <h1>Loading SARs Table...</h1>
            </div>
        );
    return (
        <div className="page-body">
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}>
                <h1>{currentYear} SARs Table</h1>
                <div>
                    {CurrentUser.permissions > 0 && <>
                        <button
                            type="button"
                            className="btn btn-warning"
                            onClick={gpcSetDefault}
                        >SET DEFAULT GPC</button>
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={gpcShareAll}
                        >SHARE ALL GPC</button>
                    </>}
                    <select
                        className="form-select"
                        id="currentYear"
                        name="currentYear"
                        value={currentYear}
                        onChange={(e) => {
                            setCurrentYear(parseInt(e.target.value))
                        }}
                        style={{marginLeft:"10px",marginRight:"20px"}}
                    >
                        {years.map((y) => 
                            <option value={y} key={y}>{y}</option>
                        )}
                    </select>
                    <IoFilterOutline
                        className="filter-icon"
                        title="Table Options and Filtering"
                        style={{margin: -5+"px"}}
                        onClick={() => setShowFilters(!showFilters)}
                    />
                </div>
            </div>
            {showFilters &&
            <div style={{minWidth:"550px"}}>
                <div className="filter-container">
                    <div className="filter-div">
                        <label
                            className="form-label filter-column"
                            htmlFor="sort1"
                        >Primary Sort</label>
                        <select
                            className="form-select"
                            id="sort1-field"
                            name="sort1-field"
                            value={filters.sort1.field}
                            onChange={(e) => setFilters({
                                ...filters,
                                sort1: {
                                    ...filters.sort1,
                                    field: e.target.value
                                }
                            })}
                        >
                            <option value={"studentName"}>Student Name</option>
                            <option value={"studentPID"}>Student PID</option>
                            <option value={"degreeType"}>Degree</option>
                            <option value={"admissionTerm"}>Admission Term</option>
                            <option value={"sarStatus"}>SAR Status</option>
                        </select>
                        <select
                            className="form-select"
                            id="sort1-direction"
                            name="sort1-direction"
                            value={filters.sort1.direction}
                            onChange={(e) => setFilters({
                                ...filters,
                                sort1: {
                                    ...filters.sort1,
                                    direction: parseInt(e.target.value)
                                }
                            })}
                        >
                            <option value={1}>Ascending</option>
                            <option value={-1}>Descending</option>
                        </select>
                    </div>
                    <div className="filter-div">
                        <label
                            className="form-label filter-column"
                            htmlFor="sort2"
                        >Secondary Sort</label>
                        <select
                            className="form-select"
                            id="sort2-field"
                            name="sort2-field"
                            value={filters.sort2.field}
                            onChange={(e) => setFilters({
                                ...filters,
                                sort2: {
                                    ...filters.sort2,
                                    field: e.target.value
                                }
                            })}
                        >
                            <option value="">None</option>
                            <option value={"studentName"} disabled={filters.sort1.field === "name"}>Student Name</option>
                            <option value={"studentPID"} disabled={filters.sort1.field === "pid"}>Student PID</option>
                            <option value={"degreeType"} disabled={filters.sort1.field === "degree"}>Degree</option>
                            <option value={"admissionTerm"} disabled={filters.sort1.field === "admission"}>Admission Term</option>
                            <option value={"sarStatus"} disabled={filters.sort1.field === "sarStatus"}>SAR Status</option>
                        </select>
                        <select
                            className="form-select"
                            id="sort2-direction"
                            name="sort2-direction"
                            value={filters.sort2.direction}
                            onChange={(e) => setFilters({
                                ...filters,
                                sort2: {
                                    ...filters.sort2,
                                    direction: parseInt(e.target.value)
                                }
                            })}
                        >
                            <option value={1}>Ascending</option>
                            <option value={-1}>Descending</option>
                        </select>
                    </div>

                    <div className="filter-div">
                        <label
                            htmlFor="status-filter"
                            className="form-label filter-column"
                        >SAR Status:</label>
                        <select
                            id="status-filter"
                            name="status-filter"
                            className="form-select"
                            value={filters.status}
                            onChange={(e) => setFilters({
                                ...filters,
                                status: parseInt(e.target.value)
                            })}
                        >
                            <option value={1}>Submitted</option>
                            <option value={0}>Unsubmitted</option>
                            <option value={2}>All</option>
                        </select>
                    </div>

                    <div className="filter-div">
                        <label
                            htmlFor="fivePlus-filter"
                            className="form-label filter-column"
                        >5+ Years Only:</label>
                        <select
                            id="fivePlus-filter"
                            name="fivePlus-filter"
                            className="form-select"
                            value={filters.fivePlus}
                            onChange={(e) => setFilters({
                                ...filters,
                                fivePlus: parseInt(e.target.value)
                            })}
                        >
                            <option value={0}>No</option>
                            <option value={1}>Yes</option>
                        </select>
                    </div>

                    <div className="filter-div">
                        <Tooltip title="At least one advisor left this score">
                            <label
                                htmlFor="progressValue-filter"
                                className="form-label filter-column"
                            >{CurrentUser.permissions > 0 ? "Faculty Scores" : "Review Scores"}*:</label>
                        </Tooltip>
                        <select
                            id="progressValue-filter"
                            name="progressValue-filter"
                            className="form-select"
                            value={filters.progressValue}
                            onChange={(e) => setFilters({
                                ...filters,
                                progressValue: parseInt(e.target.value)
                            })}
                        >
                            <option value={-1}>No Score</option>
                            <option value={0}>All Scores</option>
                            <option value={1}>Very Good Progress</option>
                            <option value={2}>Satisfactory</option>
                            <option value={3}>Unsatisfactory</option>
                            <option value={4}>Lack of Minimal Progress</option>
                        </select>
                    </div>
                    {CurrentUser.permissions > 0 ? <>
                        <div className="filter-div">
                            <label
                                htmlFor="gphStatus-filter"
                                className="form-label filter-column"
                            >GPH Status:</label>
                            <select
                                id="gphStatus-filter"
                                name="gphStatus-filter"
                                className="form-select"
                                value={filters.gphStatus}
                                onChange={(e) => setFilters({
                                    ...filters,
                                    gphStatus: parseInt(e.target.value)
                                })}
                            >
                                <option value={-1}>All</option>
                                <option value={0}>Not Started</option>
                                <option value={1}>Saved</option>
                                <option value={2}>Shared</option>
                            </select>
                        </div>
                        
                        <div className="filter-div">
                            <label
                                htmlFor="gphValue-filter"
                                className="form-label filter-column"
                            >GPH Score:</label>
                            <select
                                id="gphValue-filter"
                                name="gphValue-filter"
                                className="form-select"
                                value={filters.gphValue}
                                onChange={(e) => setFilters({
                                    ...filters,
                                    gphValue: parseInt(e.target.value)
                                })}
                            >
                                <option value={-1}>No Score</option>
                                <option value={0}>All Scores</option>
                                <option value={1}>Very Good Progress</option>
                                <option value={2}>Satisfactory</option>
                                <option value={3}>Unsatisfactory</option>
                                <option value={4}>Lack of Minimal Progress</option>
                            </select>
                        </div>
                    </>:
                        <div className="filter-div">
                            <label
                                htmlFor="milestones-filter"
                                className="form-label filter-column"
                            >Show Milestones:</label>
                            <select
                                id="milestones-filter"
                                name="milestones-filter"
                                className="form-select"
                                value={filters.milestones}
                                onChange={(e) => setFilters({
                                    ...filters,
                                    milestones: parseInt(e.target.value)
                                })}
                            >
                                <option value={1}>Yes</option>
                                <option value={0}>No</option>
                            </select>
                        </div>
                    }
                </div>
                <div className="filter-container">
                    <div className="filter-div">
                        <Tooltip title="OR Checking">
                            <label
                                className="form-label filter-column"
                                htmlFor="advisors-filter"
                                style={{verticalAlign: "top", marginTop: "0.25em"}}
                            >
                                Advisors*:
                            </label>
                        </Tooltip>
                        <div style={{display:"inline-block"}}>
                            <select
                                className="form-select"
                                id="advisors-filter"
                                value={filters.advisors}
                                onChange={(e) => setFilters({
                                    ...filters,
                                    advisors: [...e.target.selectedOptions].map(o => o.value)
                                })}
                                multiple
                                style={{height: "10em"}}
                            >
                                <option value={""}>All</option>
                                <option value={"none"}>None</option>
                                {allFaculty.map((faculty) => (
                                    <option key={faculty.pid} value={faculty.pid}>{faculty.last}, {faculty.first} ({faculty.pid})</option>
                                ))}
                            </select>
                            <br />
                            <div style={{justifySelf:"center", margin: "0.5em 0"}}>
                                <span>Hold CTRL and click to select multiple advisors</span>
                            </div>
                        </div>
                    </div>
                    
                    {CurrentUser.permissions > 0 &&
                    <div className="filter-div">
                        <label
                            htmlFor="milestones-filter"
                            className="form-label filter-column"
                        >Show Milestones:</label>
                        <select
                            id="milestones-filter"
                            name="milestones-filter"
                            className="form-select"
                            value={filters.milestones}
                            onChange={(e) => setFilters({
                                ...filters,
                                milestones: parseInt(e.target.value)
                            })}
                        >
                            <option value={1}>Yes</option>
                            <option value={0}>No</option>
                        </select>
                    </div>}

                    <div className="filter-div" style={{display:'flex' ,justifyContent:"space-between", margin:"0.5em 0 0"}}>
                        <span style={{paddingLeft: "1em"}}>Color Key:</span>
                        <span>
                            <span style={{color:"green", fontWeight:"bold"/*, textShadow:"1px 1px  black, -1px -1px  black, 1px -1px black, -1px 1px black"*/}}>Shared</span> | <span style={{color:"gold", fontWeight:"bold"/*, textShadow:"1px 1px  black, -1px -1px  black, 1px -1px black, -1px 1px black"*/}}>Not Shared</span> | <span style={{color:"red", fontWeight:"bold"/*, textShadow:"1px 1px  black, -1px -1px  black, 1px -1px black, -1px 1px black"*/}}>Incomplete or not Started</span>
                        </span>
                    </div>
                </div>
            </div>
            }
            <table className="table">
                <thead>
                    <tr>
                        <th>Student</th>
                        <th>Degree</th>
                        <th>Admitted</th>
                        {filters.milestones === 1 && <>
                            <th>Entered</th>
                            <th>Plan Of Study</th>
                            <th>Qualifier Exam</th>
                            <th>Preliminary Exam</th>
                            <th>Research Defense</th>
                            <th>Final Defense</th>
                        </>}
                        {[...Array(maxAdvisors)].map((_, index)=> (
                            <th>Advisor {index+1}</th>
                        ))}
                        <th>SAR Status</th>
                        {CurrentUser.permissions > 0 && <th>GPH Review</th>}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {/*<tr>
                        <td>Hokie Bird (hokiebird)</td>
                        <td>MS*</td>
                        <td>{displayTerm(202409)}</td>
                        {filters.milestones === 1 && <>
                            <td>Completed {displayTerm(202409)}</td>
                            <td>Completed {displayTerm(202509)}</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>Planned {displayTerm(202601)}</td>
                        </>}
                        {maxAdvisors > 0 && <>
                            <td style={{color:"green"}}>Advisor One</td>
                            <td style={{color:"#ffc107"}}>Advisor Two</td>
                            <td style={{color:"red"}}>Advisor Three</td>
                        </>}
                        <td>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => alert("Still in Progress")}
                            >View SAR</button>
                        </td>
                    </tr>*/}
                    {filteredSARs.map((sar) => (
                        <tr>
                            <td>{sar.studentName} ({sar.studentPID})</td>
                            <td> {sar.acceleratedMasters ?
                                <Tooltip title="Accelerated Masters Program">
                                    <span>MS*</span>
                                </Tooltip>
                                :
                                sar.degreeType
                                }
                            </td>
                            <td>{displayTerm(sar.admissionTerm)}</td>
                            {filters.milestones === 1 && <>
                                <td>{displayMilestone(sar.entered)}</td>
                                <td>{displayMilestone(sar.pos)}</td>
                                <td>{displayMilestone(sar.qualifier)}</td>
                                <td>{displayMilestone(sar.prelim)}</td>
                                <td>{displayMilestone(sar.research)}</td>
                                <td>{displayMilestone(sar.final)}</td>
                            </>}
                            {[...Array(maxAdvisors)].map((_, index)=> (
                                !!sar.advisors[index] ?
                                    <td style={{color: !!sar.advisors[index] && (
                                        sar.advisors[index].reviewStatus === 2 ? "green" :
                                        sar.advisors[index].reviewStatus === 1 ? "gold" :
                                        "red"
                                        ), fontWeight:"bold"/*, textShadow: "1px 1px  black, -1px -1px  black, 1px -1px black, -1px 1px black"*/}}>
                                        <Tooltip title={
                                            sar.advisors[index]?.reviewStatus === 2 ? "Shared " :
                                            sar.advisors[index]?.reviewStatus === 1 ? "Not Shared" :
                                            "Incomplete or not Started"
                                        }>
                                            <span>{!!sar.advisors[index] ? sar.advisors[index].advisorPID : "-"}</span>
                                        </Tooltip>
                                    </td>
                                : <td>-</td>
                            ))}
                            <td>{
                                sar.sarStatus === 2 ? <span style={{color:"green", fontWeight:"bold"/*, textShadow:"1px 1px  black, -1px -1px  black, 1px -1px black, -1px 1px black"*/}}>Submitted</span> :
                                sar.sarStatus === 1 ? <span style={{color:"gold", fontWeight:"bold"/*, textShadow:"1px 1px  black, -1px -1px  black, 1px -1px black, -1px 1px black"*/}}>In Progress</span> :
                                <span style={{color:"red", fontWeight:"bold"/*, textShadow:"1px 1px  black, -1px -1px  black, 1px -1px black, -1px 1px black"*/}}>Not Started</span>
                            }</td>
                            {CurrentUser.permissions > 0 &&
                            <td>{
                                sar.gphReview.reviewStatus === 2 ? <span style={{color:"green", fontWeight:"bold"}}>Shared</span> :
                                sar.gphReview.reviewStatus === 1 ? <span style={{color:"gold", fontWeight:"bold"}}>Saved</span> :
                                <span style={{color:"red", fontWeight:"bold"}}>Not Started</span>
                            }</td>}
                            <td>
                                <a
                                    className={`btn btn-primary`}
                                    href={`/sar/review/${currentYear}/${sar.studentPID}`}
                                    target="_blank"
                                >Review SAR</a>
                            </td>
                        </tr>
                    ))}
                    {filteredSARs.length === 0 &&
                        <tr>
                            <td colSpan={5 + (filters.milestones === 1 ? 6 : 0) + maxAdvisors + (CurrentUser.permissions > 0 ? 1 : 0)} style={{textAlign:"center"}}>
                                No SARs to display with current filters. Please adjust filters or select a different year.
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
            {filteredSARs.length !== 0 &&
                <span style={{display:"flex", justifyContent:"center", textAlign:"center"}}>
                    If you are not seeing the expected SARs, please adjust or clear your filters. If you believe there is an error, please contact an admin.
                </span>
            }
        </div>
    )
}